<template>
  <div class="reReview">
    <div class="searchBox">
      <!-- 以下列表为您本次复评所需评选类别，点击任一类别即可进入作品列表进行复评。 -->
      <div style="margin-bottom: 5px;">
        {{ isReadonly ? '以下列表为您本次终评作品所需评选类别，点击任一类别即可进入作品列表进行查看。' : $t('admin-judge/tip1-reReview') }}
      </div>
      <a-row :gutter="24">
        <a-col
          span="8"
          style="display: flex;"
        >
          <div class="tag">
            {{ $t('admin-profile-product/type') }}
          </div>
          <!-- 类别 -->
          <a-select
            v-model="category_id"
            style="width: 100%;"
            allow-clear
            placeholder="请选择类别"
            @change="changeCate"
          >
            <a-select-option
              v-for="item in cates"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </div>
    <!-- 表格区域 -->
    <a-table
      :columns="filteredColumns"
      :data-source="listFilter"
      class="table"
      row-key="value"
      :pagination="false"
      :scroll="{ y: 'calc(100vh - 230px)' }"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text,row,index">
        <div>
          {{ index + 1 }}
        </div>
      </span>
      <!-- 总数量 -->
      <span
        slot="num"
        slot-scope="text"
      >
        {{ text }}{{ text > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}
      </span>
      <!-- 已打分 -->
      <span
        slot="scored"
        slot-scope="text"
      >
        {{ text || 0 }}{{ (text || 0) > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}
      </span>
      <!-- 未打分 -->
      <span
        slot="unscored"
        slot-scope="text"
      >
        {{ text || 0 }}{{ (text || 0) > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}
      </span>
      <!-- 操作 -->
      <span
        slot="operation"
        slot-scope="text"
      >
        <a-button type="primary" size="small" @click="goList(text)">
          {{ isReadonly ? '查看' : '复评' }}
        </a-button>
      </span>
    </a-table>
    <div style="height: 30px;" />
  </div>
</template>
<script>
import { getReReviewCategories } from '@/api/reReview'
import { getPageKey, setPageKey } from '@/utils/auth'

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '70px'
  },
  {
    title: '类别',
    dataIndex: 'name'
  },
  {
    title: '总数量',
    dataIndex: 'num',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '已打分',
    dataIndex: 'scored',
    scopedSlots: { customRender: 'scored' }
  },
  {
    title: '未打分',
    dataIndex: 'unscored',
    scopedSlots: { customRender: 'unscored' }
  },
  {
    title: '操作',
    dataIndex: 'value',
    width: '100px',
    scopedSlots: { customRender: 'operation' }
  }
]

// 指定用户的类别白名单
const categoryWhitelistMap = {
  3769: [676, 681],
  3770: [677, 682],
  3771: [678, 683],
  3772: [679, 684],
  3773: [680, 685]
}

export default {
  data() {
    return {
      columns,
      list: [],
      cates: [], // 类别
      category_id: '' // 你选择的类别信息
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    // 根据模式动态过滤列
    filteredColumns() {
      if (this.isReadonly) {
        // 终评模式：只显示前4列（序号、类别、总数量、操作）
        return this.columns.slice(0, 3).concat(this.columns.slice(5))
      } else {
        // 复评模式：显示所有6列
        return this.columns
      }
    },
    listFilter() {
      if (this.category_id) {
        return this.list.filter(i => i.value === this.category_id)
      } else {
        return this.list
      }
    },
    // 添加只读模式检测
    isReadonly() {
      return this.$route.meta && this.$route.meta.readonly
    },
    user() {
      return this.$store.getters.user
    },
    // 当前用户可见的类别ID白名单（为空表示不过滤）
    allowedCategoryIds() {
      const uid = Number(this.user && this.user.id)
      return categoryWhitelistMap[uid] || []
    }
  },
  watch: {
    // 监听路由变化，当切换到终评页面时清空数据并重新获取
    '$route'(to, from) {
      // 检查是否从复评页面切换到终评页面，或从终评页面切换到复评页面
      const fromReadonly = from.meta && from.meta.readonly
      const toReadonly = to.meta && to.meta.readonly
      
      if (fromReadonly !== toReadonly) {
        // 清空当前数据
        this.list = []
        this.cates = []
        this.category_id = ''
        
        // 重新获取数据
        this.$nextTick(() => {
          // 重新设置列标题
          this.setColumnTitles()
          // 重新获取分类和列表数据
          this.initData()
        })
      }
    },
    locale(e) {
      this.setColumnTitles()
    },
    // 当选择的类别不在白名单中时，自动清空并同步缓存
    category_id(val) {
      if (this.allowedCategoryIds && this.allowedCategoryIds.length > 0 && val) {
        if (!this.allowedCategoryIds.includes(Number(val))) {
          this.$nextTick(() => {
            this.category_id = ''
            let pageKey = getPageKey('reReviewIndex') || '{}'
            pageKey = JSON.parse(pageKey)
            pageKey.category_id = ''
            setPageKey('reReviewIndex', JSON.stringify(pageKey))
          })
        }
      }
    }
  },
  created() {
    this.setColumnTitles()
    this.initData()

    let params = getPageKey('reReviewIndex')
    if (params) {
      params = JSON.parse(params)
      setTimeout(() => {
        if (params.category_id) this.category_id = Number(params.category_id)
      }, 300)
    }
  },
  methods: {
    // 设置列标题的方法
    setColumnTitles() {
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('admin-profile-product/type')
      this.columns[2].title = this.$t('admin-judge/quantity')
      if (this.isReadonly) {
        // 终评模式：只显示4列
        this.columns[3].title = this.$t('admin-products-products/operating')
      } else {
        // 复评模式：显示6列
        this.columns[3].title = '已打分'
        this.columns[4].title = '未打分'
        this.columns[5].title = this.$t('admin-products-products/operating')
      }
    },
    // 初始化数据的方法
    initData() {
      // 调用复评分类列表API
      getReReviewCategories().then(res => {
        console.log('getReReviewCategories', res)
        this.cates = res.cates || []
        // 根据白名单过滤下拉可选类别
        if (this.allowedCategoryIds && this.allowedCategoryIds.length > 0) {
          this.cates = this.cates.filter(c => this.allowedCategoryIds.includes(Number(c.value)))
          // 若当前选择不在白名单内，重置选择
          if (this.category_id && !this.allowedCategoryIds.includes(Number(this.category_id))) {
            this.category_id = ''
          }
        }
        this.getList()
      }).catch(error => {
        console.error('获取复评分类失败:', error)
        this.$message.error('获取复评分类失败')
      })
    },
    getList() {
      // 调用复评作品列表API
      getReReviewCategories().then(res => {
        this.list = res.lists || [] // 表格信息
        // 根据白名单过滤表格类别
        if (this.allowedCategoryIds && this.allowedCategoryIds.length > 0) {
          this.list = this.list.filter(i => this.allowedCategoryIds.includes(Number(i.value)))
        }
        if (this.user.role === 3 && res.review_record_id) { // 判断用当前登录用户的权利
          const user_id = this.user.id // 判断用户是否有工作在进行
          const that = this
          this.$confirm({
            title: '',
            content: '您有一项复评工作正在进行，是否返回继续操作。',
            okText: '确认',
            cancelText: '取消',
            onOk() {
              that.$router.push({ path: '/admin/reReviewDetail', query: { id: res.review_record_id, user_id: user_id }})
            },
            onCancel() {
            }
          })
        }
      }).catch(error => {
        console.error('获取复评列表失败:', error)
        this.$message.error('获取复评列表失败')
      })
    },
    goList(e) { // 跳转复评页面，并传入作品ID
      if (this.isReadonly) {
        // 终评作品模式，跳转到只读列表页
        this.$router.push({ path: '/admin/finalReviewList', query: { category_id: e }})
      } else {
        // 复评模式，跳转到正常列表页
        this.$router.push({ path: '/admin/reReviewList', query: { category_id: e }})
      }
    },
    changeCate(value) { // 改变category_id并传入此id到pagekey然后再储存起来，下此请求信息会自动携带
      let pageKey = getPageKey('reReviewIndex') || '{}'
      pageKey = JSON.parse(pageKey)
      pageKey.category_id = value
      setPageKey('reReviewIndex', JSON.stringify(pageKey))
    }
  }
}
</script>
<style scoped>
  .searchBox {
    padding: 17px 20px;
    background: #ffffff;
  }

  .tag {
    width: 7em;
    line-height: 32px;
  }

  .table {
    margin-top: 30px;
  }

  .content {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width: 30vw;
  }
</style>

